import React from '../../vendor/react';
import { useEffect, useState } from '../../vendor/react';
import { ShieldCheck } from '../../vendor/lucide-react';
import { Link, navigate } from '../../vendor/react-router-dom';
import { AuthLayout } from '../../components/auth/AuthLayout';
import { AuthNotice } from '../../components/auth/AuthNotice';
import { useAuth } from '../../features/auth/auth-store';

const readParams = () => {
  const source = window.location.hash.startsWith('#') ? window.location.hash.slice(1) : window.location.search.slice(1);
  return Object.fromEntries(new URLSearchParams(source).entries());
};

export function AuthCallbackPage() {
  const auth = useAuth();
  const [error, setError] = useState('');
  useEffect(() => {
    const params = readParams();
    if (params.type === 'recovery' && params.access_token) {
      navigate(`/restablecer?token=${encodeURIComponent(params.access_token)}`, { replace: true });
      return;
    }
    auth.actions.consumeCallback(params)
      .then(() => navigate(auth.workspace?.onboardingComplete ? '/app' : '/onboarding', { replace: true }))
      .catch((reason) => setError(reason instanceof Error ? reason.message : 'No se pudo completar la confirmación.'));
  }, []);
  return (
    <AuthLayout eyebrow="Confirmación segura" title="Terminando el acceso" description="Estamos validando la respuesta del proveedor de autenticación.">
      <div className="auth-confirmation-icon"><ShieldCheck size={30} /></div>
      {error ? <><AuthNotice tone="error">{error}</AuthNotice><p className="auth-card__footer"><Link to="/ingresar">Volver al acceso</Link></p></> : <div className="auth-inline-loading"><span className="loading-spinner" /><p>Validando credenciales…</p></div>}
    </AuthLayout>
  );
}
